// MUI v5: Export style objects for sx prop usage
export const pcolor = "#115C71";
export const rcolor = "#FF767E";
export const lightpinkcolor = "#FAE6EC";
export const blackcolor = "#000000";
export const whitecolor = "#FFFFFF";
export const orangecolor = "#ff914d";
export const darkcolor = "#545454";
export const lightcolor = "#F6F6F6";
export const primaryColor = "#115C71";
export const brownColor = "#6b3a08";
export const registrationHeader = {
  width: 180,
}
export const redHeading = { padding: "20px 0px 20px 0px", color: rcolor, fontWeight: "bold", fontSize: "1.8rem" }
export const colorcard = { padding: "10px 20px", fontSize: "1rem", textTransform: "capitalize", borderRadius: "20px", height: "95px", position: "relative", '&:hover': { border: "2px solid #F6F6F6" } };
export const bodyBg = { background: "#F1EFDF" };
export const bodyBg2 = { background: "#f2eee4" };
export const fullHeight = { minHeight: '100vh' };
export const scrollMargin = { scrollMarginTop: "118px", scrollBehavior: "smooth" };
export const filterdropdownitem = { display: "inline-block", minWidth: "130px", color: pcolor, marginBottom: "5px" };
export const pointer = { cursor: "pointer" };
export const disableBox = { backgroundColor: lightcolor, padding: "5px 10px", borderRadius: "10px", fontSize: "18px" };
export const uploadiconborder = { background: "rgba(255, 118, 126, 0.1)", borderRadius: 8, padding: 2, marginRight: 2, position: "relative" };
export const select = { fontSize: "17px" };
export const cardgrey = { borderRadius: "15px", border: "1px solid #fff", backgroundColor: lightcolor, padding: "20px" };
export const healthProfileLinkDashboard = { padding: "20px 10px", background: "#FAE6EC", borderRadius: "10px", textAlign: "center", color: pcolor, fontWeight: "bold", fontSize: "1.1rem" };
export const epilepsyHeading2 = { textAlign: "center", color: pcolor, fontWeight: "bold", fontSize: "1.1rem", marginBottom: "15px" };
export const smallcircle = { height: "10px", width: "10px", borderRadius: "10px", backgroundColor: "#FF86A5", display: "inline-block" };
export const smallcirclereffered = { height: "10px", width: "10px", borderRadius: "10px", display: "inline-block", backgroundColor: "#51C3F4" };
export const smallcirclemeasured = { height: "10px", width: "10px", borderRadius: "10px", display: "inline-block", backgroundColor: "#831AFA" };
export const smallcirclewaiting = { height: "10px", width: "10px", borderRadius: "10px", display: "inline-block", backgroundColor: "#EA7306" };
export const smallcirclesupplied = { height: "10px", width: "10px", borderRadius: "10px", display: "inline-block", backgroundColor: "#E7FF54" };
export const smallcircleusing = { height: "10px", width: "10px", borderRadius: "10px", display: "inline-block", backgroundColor: "#4BC0A9" };
export const smallcircleoutgrown = { height: "10px", width: "10px", borderRadius: "10px", display: "inline-block", backgroundColor: "orange" };
export const carejourneytabcontainer = { overflowY: "auto", maxHeight: 400 };
export const carejourneytabheading = { fontSize: "18px", fontWeight: "bold", color: pcolor, paddingBottom: "15px" };
export const footerContainer = { position: "fixed", bottom: "0", width: "100%", textAlign: "center" };
export const fsSmall = { fontSize: "0.85rem" };
export const paddingbox = {
  paddingLeft: { xs: "150px", md: "170px" },
  paddingTop: { xs: "35px", md: "25px", lg: "30px" },
  paddingRight: { xs: "30px", md: "45px" },
};
export const paddingboxeven = {
  paddingLeft: { xs: "30px", md: "45px" },
  paddingTop: { xs: "35px", md: "25px", lg: "30px" },
  paddingRight: { xs: "30px", md: "45px" },
};
export const header = {
  paddingLeft: { xs: "150px", md: "170px" },
  paddingTop: { xs: "35px", md: "20px" },
  paddingRight: { xs: "10px", md: "45px" },
  backgroundColor: whitecolor, position: "sticky", width: "100%", zIndex: "1", top: 0
};
export const headerEven = {
  paddingLeft: { xs: "100px", md: "45px" },
  paddingTop: { xs: "35px", md: "20px" },
  paddingRight: { xs: "10px", md: "45px" },
  backgroundColor: whitecolor, position: "sticky", width: "100%", zIndex: "1", top: 0
};
export const paddingBottom = { paddingBottom: 50 };
export const headerText = {
  fontFamily: "Lato",
  fontStyle: "normal",
  fontWeight: "bold",
  fontSize: { xs: 18, md: 24 },
  color: pcolor,
};

export const buttonback = { fontFamily: "Lato", fontStyle: "normal", fontWeight: "normal", fontSize: "16px", borderRadius: 20, padding: "3px 20px 3px 10px", color: "#FFFFFF", backgroundColor: pcolor, textTransform: "unset", '&:hover': { background: "#E7F1EA", color: pcolor } };
export const IconBell = { color: rcolor, fontSize: 30, width: 30 };
export const smallText = { fontSize: "0.7rem" };
export const underheaderText = { fontWeight: "normal", fontSize: 12, color: rcolor };
export const horizontalLine = { height: 0, left: 210.17, top: 119.16, border: "3px solid white", backgroundColor: "white" };
export const button = { width: 140, height: 40, background: "#FFFFFF", border: "1px solid #FF767E", boxSizing: "border-box", borderRadius: 9, textTransform: "unset", color: rcolor, '&:hover': { color: "#FFFFFF", background: rcolor } };
export const buttonRed = { width: 140, height: 40, background: rcolor, border: "1px solid #FF767E", boxSizing: "border-box", borderRadius: 9, textTransform: "unset", color: "#FFFFFF", '&:hover': { color: "#000000", background: rcolor } };

export const w100 = { width: "100%" };
export const label = { color: pcolor, fontWeight: "bold", marginBottom: "8px", cursor: "pointer" };
export const buttonPrimaryLight = { background: "#ffffff", border: "0px", boxSizing: "border-box", borderRadius: 9, textTransform: "unset", color: pcolor, '&:hover': { color: "#ffffff", background: pcolor } };
export const buttonPrimary = { background: pcolor, border: "0px", boxSizing: "border-box", borderRadius: 9, textTransform: "unset", color: "#ffffff", '&:hover': { color: pcolor, background: "#ffffff" }, '&:focus': { color: "#ffffff", background: pcolor } };
export const right = { marginLeft: "auto" };
export const name = { fontWeight: "bold", fontSize: "24px", color: pcolor };
export const dashboardText = { fontWeight: "bold", fontSize: "22px", color: pcolor };
export const myCalendarAlignment = {
  paddingTop: { xs: 0 },
};
export const appointmentsText = { fontWeight: "bold", fontSize: 16, textTransform: "uppercase", color: "#001244" };
export const buttonReverseColors = { width: 140, height: 40, background: "#FFFFFF", border: "1px solid #FF767E", boxSizing: "border-box", borderRadius: 9, textTransform: "unset", color: rcolor, '&:hover': { color: "#FFFFFF", background: rcolor } };
export const calendar = { fontSize: 13, borderRadius: 9 };
export const dateShownText = { fontWeight: "bold", fontSize: 14, color: pcolor };
export const mainGrid = { border: "1px solid #fff", backgroundColor: lightcolor, borderRadius: "9px", padding: "20px" };
export const appointmentDate = { background: "#EBEEFF", borderRadius: 8, padding: "2px 8px 2px 8px" };
export const appointmentDateDay = { fontWeight: "normal", fontSize: 25, color: "#001244" };
export const appointmentDateMonth = { fontWeight: "normal", fontSize: 12, color: "#001244" };
export const appointmentTime = { fontWeight: "bold", fontSize: 14, color: pcolor };
export const line = { border: "0.6px solid rgba(133, 138, 145, 0.4)" };
export const deleteIcon = { color: "rgba(242, 73, 50, 0.55)" };
export const editIcon = { color: "rgba(17, 92, 113, 0.7)" };
export const scroll = {
  overflow: "auto",
  maxHeight: { xs: 408 },
};
export const mypatientPadding = { paddingTop: 20, backgroundColor: "white", borderRadius: 9, paddingBottom: 20 };
export const paginationPadding = {
  paddingLeft: { xs: 100, md: 250 },
  paddingTop: { xs: 35, md: 50 },
  paddingRight: { xs: 30, md: 50 },
  paddingBottom: { xs: 35, md: 50 },
};
export const maintextlist = { fontWeight: "bold", fontSize: 16, color: pcolor };
export const pagination = { '& .MuiPaginationItem-root': { color: rcolor }, '& .Mui-selected': { backgroundColor: rcolor, color: "white", '&:hover': { color: rcolor, backgroundColor: "white" } }, '& .MuiPaginationItem-icon': { backgroundColor: "#EBEEFF", color: rcolor, borderRadius: 50 } };
export const title = { fontWeight: "bold", fontSize: 25, color: "#001244" };
export const personalInfoGrid = { background: "#FFFFFF", borderRadius: 10, paddingTop: 25, paddingLeft: 25, paddingBottom: 25 };
export const infoHeader = { fontFamily: "Lato", fontStyle: "normal", fontWeight: "bold", fontSize: 14, color: pcolor };
export const infoText = { fontFamily: "Lato", fontStyle: "normal", fontWeight: "normal", fontSize: 12, color: pcolor };
export const buttonNoOutline = { fontFamily: "Lato", fontStyle: "normal", fontWeight: "normal", fontSize: 14, color: rcolor, textTransform: "unset", '&:hover': { background: "#FFFFFF", color: rcolor } };
export const personalInfoMargin = { marginTop: "20px", marginBottom: "20px" };
export const appbar = {
  display: { xs: "none" },
};
export const homeImageMainOpen = { width: "auto", maxWidth: "100%" };
export const homeImageMainClose = { paddingLeft: 10, width: 40, height: 25.43 };
export const homeProfileImageOpen = { width: 55.94, height: 57.66, borderRadius: 50, backgroundColor: rcolor, border: "5px solid #FF767E", borderTopLeftRadius: 50, borderBottomRightRadius: 50, borderBottomLeftRadius: 50, borderTop: 0, borderRight: 0 };
export const homeProfileImageClose = { width: 35.94, height: 37.66, borderRadius: 50, backgroundColor: rcolor, border: "5px solid #FF767E", borderTopLeftRadius: 90, borderBottomRightRadius: 90, borderBottomLeftRadius: 90, borderTopRightRadius: 85, borderTop: 0, borderRight: 0 };
export const homeSideBarNameText = { color: rcolor };
export const homeSideBarTitleText = { color: pcolor };
export const iconSelectedHome = { color: rcolor, fontSize: 30, width: 30 };
export const iconUnselectedHome = { color: pcolor, fontSize: 30, width: 30 };
export const selectedOption = { fontFamily: "Lato", fontStyle: "normal", fontWeight: "bold", fontSize: 14, color: rcolor, paddingTop: 5 };
export const iconUnselectedMyRecords = { color: pcolor, fontSize: 25, width: 30 };
export const iconSelectedMyRecords = { color: rcolor, fontSize: 25, width: 30 };
export const unselectedOption = { width: 76.39, fontFamily: "Lato", fontStyle: "normal", fontWeight: "bold", fontSize: 14, color: pcolor, paddingTop: 5 };
export const iconUnselectedSettings = { color: pcolor, fontSize: 25, width: 30 };
export const iconSelectedSettings = { color: rcolor, fontSize: 25, width: 30 };
export const icon34 = { width: "30px", height: "30px" };
export const IconLogOut = { color: rcolor, fontSize: 30, width: 30 };
export const tabPanelHealthProfile = { '& .MuiBox-root': { padding: 0 }, paddingBottom: 20 };
export const textFieldOutlineDisabled = { border: "none", borderRadius: 2, background: "rgba(17, 92, 113, 0.04)" };
export const textFieldOptional = { background: "rgba(17, 92, 113, 0.04)", borderRadius: 2, border: "0.5px solid grey", margin: "auto" };
export const textFieldTitle = { fontWeight: 500, fontSize: 14, color: "#001244", marginBottom: -5 };
export const menuPaper = { maxHeight: 250 };
export const paper = {
  padding: "5px",
  margin: "auto",
  maxWidth: 870,
  borderRadius: 9,
};
export const imageIcon = { width: 40 };
export const eventTab = {
  padding: { xs: 0, md: 15 },
  paddingLeft: { xs: 0, md: 50 },
  paddingRight: { xs: 0, md: 50 },
  backgroundColor: "white",
  textTransform: "capitalize",
};
export const eventsPadding = {
  padding: { xs: 0, md: 30 },
};
export const custompadding = { paddingTop: 50 };
export const tabLabel = { whiteSpace: "nowrap" };
export const eventTabPanel = { width: "100%", padding: "0px", margin: "0px" };
export const eventDateTime = { background: "grey", border: "1px solid white", color: whitecolor, height: "70px", padding: "10px", margin: "0px" };
export const eventDetails = { background: "#d3d3d3", border: "1px solid white", padding: "10px", height: "70px", margin: "0px" };
export const eventTitle = { fontSize: "16px", marginBottom: "5px" };
export const dialogEditEvent = { padding: 1 };
export const imageIconToDo = { width: 30 };
export const imageIconSplintsAndEquipment = { width: 30 };
export const floatingPlusIcon = { position: "absolute", bottom: 0, right: 0 };
export const tableRowOdd = { backgroundColor: "#F2FCFB" };
export const buttonviewmore = {
  fontFamily: "Lato",
  fontStyle: "normal",
  fontWeight: "normal",
  fontSize: 14,
  color: rcolor,
  textTransform: "unset",
  "&:hover": {
    background: whitecolor,
  },
};
export const selectUnderLined = {
  padding: "8px",
  borderRadius: "0px",
  fontSize: "1rem",
  backgroundColor: "transparent",
  border: "0px",
  borderBottom: "1px solid " + pcolor
};